import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWR from 'swr';
import type { ProvidersResponse } from '@/entities/provider/model/types';

export function useProviders() {
  const { data, error, isLoading } = useSWR<ProvidersResponse>(
    '/providers',
    fetcherWithToken
  );
  return {
    isLoading,
    providers: data,
    isError: error,
  };
}
